import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { PORTAL_REMEMBER_ME_KEY, migrateLegacyRememberMe } from '../../../../libs/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    // Older builds stored the login password as readable plaintext under the
    // "remember me" key. Re-encrypt at bootstrap rather than leaving it to the
    // login component: a user who ticked the box and is still signed in never
    // mounts /login, so the plaintext would otherwise sit in their localStorage
    // indefinitely. Not awaited — prefilling the login form is not something
    // app startup should block on.
    provideAppInitializer(() => {
      void migrateLegacyRememberMe(PORTAL_REMEMBER_ME_KEY);
    }),
    provideClientHydration(withEventReplay()),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withFetch()),
    provideRouter(appRoutes),
  ],
};
